<navbar></navbar>
<debug-button></debug-button>
<router-outlet></router-outlet>